import { useState } from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import IconButton from '@mui/material/IconButton';
// import Button from '@mui/material/Button';
import Badge from '@mui/material/Badge';
import { faFilter } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Grid from '@mui/material/Grid';
import useTheme from '@mui/material/styles/useTheme';
import POISearch from './POISearch';
import FilterTowerDistance from './FilterTowerDistance';
import FiltersDialog from './FiltersDialog';

const StyledToolbar = styled(Toolbar)(({ theme }) => ({
    justifyContent: "space-between",
    paddingRight: '8px',
    // Override media queries injected by theme.mixins.toolbar
    '@media all': {
        minHeight: 72 //(90 - theme.spacing(1) - theme.spacing(2))
    },
}));


const Header = ({ map, viewbox, searchMarker, setSearchMarker, towerFilters, setTowerFilters }) => {
    const theme = useTheme();
    const onlySmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
    // const onlyMediumScreen = useMediaQuery(theme.breakpoints.down("md"));

    const [dialogOpen, setDialogOpen] = useState(false);
    const filterCount = Object.keys(towerFilters).filter(x => towerFilters[x] !== null).filter(f => towerFilters[f].length > 0).length;

    const handleClickOpen = () => {
        setDialogOpen(true);
    };

    return (
        <Box sx={{ flexGrow: 1 }}>
            <AppBar position="fixed" elevation={0} sx={{ bgcolor: "#E8E8E8" }}>
                <StyledToolbar>

                    <Grid container spacing={1}>
                        <Grid item xs={10} sm={7} md={6} sx={{ flexGrow: 1 }}>
                            <POISearch map={map} viewbox={viewbox} setSearchMarker={setSearchMarker} setTowerFilters={setTowerFilters} />
                        </Grid>

                        {!onlySmallScreen &&
                            <Grid sm={4} md={3} item >
                                <FilterTowerDistance searchMarker={searchMarker} towerFilters={towerFilters} setTowerFilters={setTowerFilters} />
                            </Grid>
                        }

                        {/* This is temporary until we get the full filters implemented */}
                        {onlySmallScreen &&
                            <Grid xs={2} sm={1} item>
                            <Grid container justifyContent="flex-end">
                                <IconButton className='faTimes' onClick={handleClickOpen} size="large" color="primary" >
                                    <Badge badgeContent={filterCount} color="error">
                                        <FontAwesomeIcon icon={faFilter} />
                                    </Badge>
                                </IconButton>
                            </Grid>
                        </Grid>
                        }

                        {/* This will be for when we get the full filters implemented */}
                        {/* {!onlyMediumScreen ? (
                            <Grid md={3} item >
                                <Grid container justifyContent="flex-end">
                                    <Button sx={{ m: 1 }} variant="outlined" size="large" onClick={handleClickOpen} endIcon={<FontAwesomeIcon icon={faFilter} />}>
                                        <Badge badgeContent={filterCount} color="error" style={{ transform: 'translate(100px, -18px)' }} />
                                        Filters
                                    </Button>
                                </Grid>
                            </Grid>
                        ) : (
                            <Grid xs={2} sm={1} item>
                                <Grid container justifyContent="flex-end">
                                    <IconButton onClick={handleClickOpen} size="large" color="primary" >
                                        <Badge badgeContent={filterCount} color="error">
                                            <FontAwesomeIcon icon={faFilter} />
                                        </Badge>
                                    </IconButton>
                                </Grid>
                            </Grid>
                        )} */}

                    </Grid>
                </StyledToolbar>
            </AppBar>

            <FiltersDialog dialogOpen={dialogOpen} setDialogOpen={setDialogOpen} searchMarker={searchMarker} towerFilters={towerFilters} setTowerFilters={setTowerFilters} />

        </Box>
    );
}

export default Header;